import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=52127770&"
import script from "./NotificationSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSettings.vue?vue&type=style&index=0&id=52127770&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports